import { Component, Element, Event, EventEmitter, h, Host, Prop } from '@stencil/core'
import { injectGlobal } from 'src/lib/emotion'

injectGlobal`
  ui-content {
    *:not(pre) > code {
      padding: 0.2em 0.5em !important;
    }
    pre {
      line-height: 1.2 !important;
    }
    code {
      font-size: 0.8em !important;
    }
  }
`

const styles = {
  h1: 'my-3 text-4xl font-semibold tracking-tight last:mb-0',
  h2: 'my-3 text-3xl font-semibold tracking-tight last:mb-0',
  h3: 'my-3 text-2xl font-semibold tracking-tight last:mb-0',
  h4: 'my-3 text-xl font-semibold tracking-tight last:mb-0',
  code: 'font-mono rounded-sm last:mb-0 whitespace-pre',
  p: 'mb-3 text-base font-normal last:mb-0',
  hr: 'my-3 last:mb-0 border-surface-higher',
  ul: 'mb-4 ml-4 list-disc last:mb-0',
  ol: 'mb-4 ml-4 list-decimal last:mb-0',
  li: 'pl-1 mb-1 last:mb-0',
  td: 'px-3 py-2 border-b border-surface-high last:border-b-0',
  th: 'px-3 pb-2 text-left border-b-4 border-surface-high',
  table: 'mb-3',
  img: 'my-3 last:mb-0',
  a: 'underline text-link',
}

const stylesSmall = {
  h1: 'my-2 text-xl font-semibold tracking-tight last:mb-0',
  h2: 'my-2 text-lg font-semibold tracking-tight last:mb-0',
  h3: 'mb-2 mt-4 text-md font-semibold tracking-tight last:mb-0',
  h4: 'my-2 text-md font-semibold tracking-tight last:mb-0',
  code: 'font-mono rounded-sm last:mb-0 whitespace-pre',
  p: 'mb-3 text-sm font-normal last:mb-0',
  hr: 'my-2 last:mb-0 border-surface-higher',
  ul: 'mb-4 ml-4 list-disc last:mb-0',
  ol: 'mb-4 ml-4 list-decimal last:mb-0',
  li: 'pl-1 mb-1 last:mb-0 text-sm',
  td: 'px-3 py-2 border-b border-surface-high last:border-b-0',
  th: 'px-3 pb-2 text-left border-b-4 border-surface-high',
  table: 'mb-3',
  img: 'my-3 last:mb-0',
  a: 'hover:underline hover:text-link',
}

@Component({
  tag: 'ui-content',
})
export class Content {
  @Element() el: HTMLUiContentElement

  @Event({ bubbles: true }) uiContentElementAdded: EventEmitter<HTMLElement>
  @Prop() src: string
  @Prop() small = false

  componentDidRender() {
    for (const [tag, classStr] of Object.entries(this.small ? stylesSmall : styles)) {
      const classes = classStr.split(' ')
      this.el.querySelectorAll<HTMLElement>(tag).forEach((el) => {
        el.classList.add(...classes)
        this.uiContentElementAdded.emit(el)
      })
    }
  }

  render() {
    return <Host {...(this.src ? { innerHTML: this.src } : {})} />
  }
}
